export function setupBuyForm() {
  var $trigger = jQuery("#click-to-buy");
  $trigger.click(function (e) {
    console.log("click to buy");
    const carByForm = document.querySelector(".buy-car-id");
    if (!carByForm) {
      return;
    }
    const primaryMainSection = document.querySelector("#primary");
    if (!primaryMainSection) {
      return;
    }
    const internalCarId = primaryMainSection.getAttribute("data-internal-id");
    const hiddenInternalCarId = document.querySelector(
      "#wpforms-1032-field_10"
    );
    if (hiddenInternalCarId) {
      hiddenInternalCarId.value = internalCarId;
    }

    // const child = carByForm.children[0];
    // const carId = document.querySelector("#primary").dataset("car");
    // const internalId = document
    //   .querySelector("#primary")
    //   .dataset("internal-id");
    // const carName = document.querySelector("#primary").dataset("car-name");

    // if (internalId) {
    //   child.value = internalId;
    // } else if (carId) {
    //   child.value = "Id: " + carId + " - " + carName;
    // } else {
    //   child.value = carName;
    // }
  });
}
